import React, { useState } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import dayjs from 'dayjs';

const Calendar = ({ onDateClick }) => {
  const today = dayjs();
  const [currentMonth, setCurrentMonth] = useState(today.startOf('month'));
  const [inputValue, setInputValue] = useState(currentMonth.format('MM — MMMM / YYYY'));
  
  // Add selectedDate state
  const [selectedDate, setSelectedDate] = useState(null);

  // Updates calendar grid from currentMonth
  const getCalendarDays = () => {
    const startDay = currentMonth.startOf('week');
    const endDay = currentMonth.endOf('month').endOf('week');

    const days = [];
    let date = startDay;

    while (date.isBefore(endDay, 'day') || date.isSame(endDay, 'day')) {
      days.push(date);
      date = date.add(1, 'day');
    }

    return days;
  };

  const calendarDays = getCalendarDays();

  const handlePrevMonth = () => {
    const newMonth = currentMonth.subtract(1, 'month');
    setCurrentMonth(newMonth);
    setInputValue(newMonth.format('MM — MMMM / YYYY'));
    setSelectedDate(null); // Optional: reset selected date when changing month
  };

  const handleNextMonth = () => {
    const newMonth = currentMonth.add(1, 'month');
    setCurrentMonth(newMonth);
    setInputValue(newMonth.format('MM — MMMM / YYYY'));
    setSelectedDate(null); // Optional: reset selected date when changing month
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputBlur = () => {
    const parsed = dayjs(inputValue, ['MM — MMMM / YYYY', 'MMMM YYYY', 'MM/YYYY'], true);
    if (parsed.isValid()) {
      const startOfMonth = parsed.startOf('month');
      setCurrentMonth(startOfMonth);
      setInputValue(startOfMonth.format('MM — MMMM / YYYY'));
      setSelectedDate(null); // Optional reset
    } else {
      setInputValue(currentMonth.format('MM — MMMM / YYYY'));
    }
  };

 const handleDateClick = (day) => {
  const formatted = day.format('YYYY-MM-DD'); // 👈 API expects this format
  setSelectedDate(day);
  if (onDateClick) onDateClick(formatted);
};


  return (
    <Container fluid className="p-0">
      <div className="p-3 border rounded shadow-sm bg-white" style={{ minHeight: '100%' }}>
        {/* Header: Editable Month */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          <Form.Control
            size="sm"
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            style={{ width: 'auto', fontWeight: 'bold' }}
            className="fw-bold"
          />
          <div>
            <Button size="sm" variant="outline-secondary" onClick={handlePrevMonth} className="me-2">
              ‹
            </Button>
            <Button size="sm" variant="outline-secondary" onClick={handleNextMonth}>
              ›
            </Button>
          </div>
        </div>

        {/* Week Days Header */}
        <Row className="text-center fw-bold text-uppercase small mb-2">
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d) => (
            <Col key={d}>{d}</Col>
          ))}
        </Row>

        {/* Days Grid */}
        {Array.from({ length: Math.ceil(calendarDays.length / 7) }, (_, weekIdx) => (
          <Row key={weekIdx} className="text-center mb-1">
            {calendarDays.slice(weekIdx * 7, weekIdx * 7 + 7).map((day) => {
  const isToday = day.isSame(today, 'day');
  const isSelected = selectedDate ? day.isSame(selectedDate, 'day') : false;

  return (
    <Col
      key={day.format('YYYY-MM-DD')}
      className={`py-2 rounded ${
        isSelected
          ? 'bg-primary text-white'       // Selected date is always blue
          : !selectedDate && isToday       // Today is gray only if nothing selected
          ? 'bg-secondary text-white'
          : ''
      }`}
      style={{ cursor: 'pointer' }}
      onClick={() => handleDateClick(day)}
    >
      {day.format('D')}
    </Col>
  );
})}

          </Row>
        ))}
      </div>
    </Container>
  );
};

export default Calendar;
